import { gql } from '@apollo/client'

export const Query = gql`
  query AssetCases(
    $companyId: ID!,
    $filters: AssetCaseFilters,
    $order: AssetCaseOrder,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    assetCases(
      companyId: $companyId,
      filters: $filters,
      order: $order,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        barcode {
          barcode
        }
        assetCount
        description
        warehouse {
          id
          name
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
